// extracted by mini-css-extract-plugin
module.exports = {"btn":"ChangeUserPassword_btn__3ukMB"};